<template>
  <authorization-form></authorization-form>
</template>

<script>
  import AuthorizationForm from './authorizationForm'
  export default {
    name: "authorizationLogin",
    components: {
      AuthorizationForm
    }
  }
</script>
